import type { getAdminComfortTradeSendersInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAdminComfortTradeSenders: getAdminComfortTradeSendersInput;
}

const ADMIN_COMFORT_TRADE_SENDERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"admin-comfort-trade-senders",
	["useGetAdminComfortTradeSenders"],
);

export { ADMIN_COMFORT_TRADE_SENDERS_SERVICE_KEYS };
